import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Fishermans Bend – Project Overview</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          Fishermans Bend is Australia’s largest urban renewal project covering approximately 485 hectares and consisting of five precincts in the heart of Melbourne. 
        </p>
        <p>
          Water is pivotal to the design of this community and we'll deliver an integrated water system, which leverages the entire water cycle, to showcase innovative environmental and sustainable initiatives. 
        </p>
        <p>
          To deliver a reliable recycled water supply in Fishermans Bend, we’ll design and construct a Water Recycling Plant, a recycled water distribution network that includes recycled water mains and reticulation pipes, and also a Sewer Mining Pump Station. 
        </p>
        <p>
          For more project information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/projects/fishermans-bend/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Fishermans Bend',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800055465">1800 055 465</a> |{' '}
          <a
            href="mailto:FishermansBend@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: FishermansBend@sew.com.au - Fishermans Bend',
              });
            }}
          >
            FishermansBend@sew.com.au
          </a>
        </p>
        <p>
        To learn more about Recycled Water click{' '}
          <a
            href="https://southeastwater.com.au/water-waste-and-environment/learn-about-water/recycled-water/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Recycled Water',
              });
            }}
          >
            here
          </a>.
        </p>
        <p>
        Read the{' '}
          <a
            href="https://www.vic.gov.au/fishermans-bend-framework"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Fishermans Bend Framework',
              });
            }}
          >
            Fishermans Bend Framework
          </a> and {' '}
          <a
            href="https://www.vic.gov.au/sites/default/files/2025-01/Fishermans-Bend-Water-Sensitive-City-Strategy-%281%29-%281%29.pdf"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Water Sensitive City strategy',
              });
            }}
          > 
            Water Sensitive City strategy
          </a> for more information. 
        </p>
      </div>
    </>
  );
};

export default Content;
